module.exports = __webpack_public_path__ + "photo2.png?a1c1a4747260a385463b75fb9eb33d84";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photo2.png
// module id = 54
// module chunks = 0